export default "__VITE_ASSET__2f161315__"